var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"course-lesson-list"},[(_vm.lessonList.length)?_c('div',{staticClass:"course-sort",on:{"click":_vm.changeSort}},[_c('ym-icon',{staticClass:"icon",attrs:{"name":"mr-sort"}}),_vm._v("\n    "+_vm._s(_vm.sortText)+"\n  ")],1):_vm._e(),_vm._l((_vm.lessonList),function(item,index){return _c('item',{key:index,attrs:{"course-id":_vm.courseId,"lesson":{
          id: item.id,
          title: item.title,
          seq: item.seq,
        },"work":item.work,"practice":item.practice,"challenge":item.challenge,"summary":item.summary}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }